/* eslint-disable react/jsx-props-no-spreading */
import { ReactNode, ReactElement } from 'react'
import Typography, { TypographyProps } from '@mui/material/Typography'
import makeStyles from '@mui/styles/makeStyles'

// type StylesProps = {
//   readonly iconPosition?: string
// }

const useStyles = makeStyles(() => ({
  box: {
    display: 'flex',
    alignItems: 'center'
  }
}))

interface Props extends TypographyProps {
  readonly icon: ReactNode
  readonly children: ReactNode
  readonly iconPosition?: string
}

function TextWithIcon({ icon, children, iconPosition = 'left', ...rest }: Props): ReactElement {
  const classes = useStyles({ iconPosition })
  return (
    <div className={classes.box}>
      {iconPosition === 'left' && <>{icon}</>}
      <Typography {...rest}>{children}</Typography>
      {iconPosition === 'right' && <>{icon}</>}
    </div>
  )
}

export default TextWithIcon
